import { type StateCreator } from 'zustand';

export type PanelSlice = {
  open: boolean;
  touched: boolean;
  clearOpen: () => void;
  setOpen: (open: boolean) => void;
  toggleOpen: () => void;
};

export type CreatePanelSlice = (
  initialState: Pick<Partial<PanelSlice>, 'open' | 'touched'>,
) => StateCreator<PanelSlice, [], [], PanelSlice>;

export const createPanelSlice: CreatePanelSlice = (initialState) => (set) => ({
  open: initialState.open ?? false,
  touched: initialState.touched ?? false,
  clearOpen: () =>
    set({
      open: initialState.open ?? false,
      touched: initialState.touched ?? false,
    }),
  setOpen: (open) => set({ open, touched: true }),
  toggleOpen: () => set((state) => ({ open: !state.open, touched: true })),
});
